import { Segment } from 'component/Space/Segment'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import { store } from 'store/store'
import { getTermLabel, TermType } from 'type/term'

type Props = {
  value: TermType
}

export const TermButton = observer(({ value }: Props) => {
  const term = store.profile.term!
  const type = term.value
  const disabled = !term.canBe(value)

  const onClick = useLatestCallback(() => {
    term.value = value
  })

  return <Segment filled active={type === value} disabled={disabled} action={onClick}>
    {getTermLabel(value)}
  </Segment>
})
